<tt-field-group v-bind="{ asFieldset: true, labelId, describedbyId, errorText, hintText, label, required }">
  <div class="tt-c-rating tt-c-rating--actionable">
    <span v-for="n in 5"
              :ref="setStarRef"
              role="radio"
              class="tt-c-rating__star tt-o-button--icon"
              :aria-checked="modelValue >= n ? 'true' : 'false'"
              :aria-describedby="describedbyIdValue"
              :name="labelId"
              :tabindex="modelValue === n || (modelValue === 0 && n === 1) ? '0' : '-1'"
              @click.stop="ratingSelected($event, n)"
              @keydown="ratingSelected($event, n)"
              @mouseenter="ratingEnter(n)"
              @mouseleave="ratingLeave()"
              :key="n">
      <tt-icon v-if="rating < n" name="star--empty" class="tt-c-rating__icon" :size="starSize"></tt-icon>
      <tt-icon v-if="rating >= n" name="star--full" class="tt-c-rating__icon" :size="starSize"></tt-icon>
      <span class="tt-u-clip-hide" v-html="$msg('ratingStars.selectToRate', [n], n)"></span>
    </span>
  </div>
</tt-field-group>
